import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Typography, TextField, Button, Checkbox, FormControlLabel, Box, 
  Autocomplete, Radio, RadioGroup, FormControl, FormLabel, Switch, 
  Select, MenuItem, InputLabel, Divider 
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate } from 'react-router-dom';
import { getIdToken } from './Firebase';

const AddMatch = () => {
  const navigate = useNavigate();
  const [homeTeam, setHomeTeam] = useState(null);
  const [awayTeam, setAwayTeam] = useState(null);
  const [matchDate, setMatchDate] = useState(new Date());
  const [homeGoals, setHomeGoals] = useState('');
  const [awayGoals, setAwayGoals] = useState('');
  const [neutralVenue, setNeutralVenue] = useState(false);
  const [teamOptions, setTeamOptions] = useState([]);
  const [searchTermHome, setSearchTermHome] = useState('');
  const [searchTermAway, setSearchTermAway] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [kValue, setKValue] = useState('10'); // Domyślna wartość K

  // Nowe stany dla systemu barażowego
  const [isPlayoffMatch, setIsPlayoffMatch] = useState(false);
  const [playoffRounds, setPlayoffRounds] = useState([]);
  const [playoffRoundId, setPlayoffRoundId] = useState('');
  const [isSecondLeg, setIsSecondLeg] = useState(false);
  const [winnerTeamId, setWinnerTeamId] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = await getIdToken();
        const headers = token ? { Authorization: `Bearer ${token}` } : {};
        // Pobieranie opcji drużyn
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/teams`, { headers });
        const data = response.data;
        const teams = data.map(team => ({
          id: team.teamId,
          name: team.teamName,
          elo: team.eloRanking,
        }));
        setTeamOptions(teams);

        // Pobieranie rund barażowych ze złączonymi nazwami szablonów
        const playoffResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/playoff-rounds`, { headers });
        setPlayoffRounds(playoffResponse.data || []);

        setLoading(false);
      } catch (err) {
        setError('Błąd podczas pobierania danych z API.');
        console.error('Błąd API:', err);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredTeamsHome = teamOptions.filter(team =>
    !homeTeam || team.id !== homeTeam.id
  ).filter(team =>
    team.name.toLowerCase().includes(searchTermHome.toLowerCase())
  );

  const filteredTeamsAway = teamOptions.filter(team =>
    !awayTeam || team.id !== awayTeam.id
  ).filter(team =>
    team.name.toLowerCase().includes(searchTermAway.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = await getIdToken();
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const homeElo = homeTeam ? homeTeam.elo : null;
      const awayElo = awayTeam ? awayTeam.elo : null;
      
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/matches`, {
        homeTeamId: homeTeam.id,
        awayTeamId: awayTeam.id,
        homeTeamName: homeTeam.name,
        awayTeamName: awayTeam.name,
        matchDate: matchDate.getTime(),
        homeGoals: homeGoals ? parseInt(homeGoals) : null,
        awayGoals: awayGoals ? parseInt(awayGoals) : null,
        neutralVenue,
        homeElo,
        awayElo,
        kValue: parseInt(kValue),
        
        // Przekazywanie nowych danych do backendu
        isPlayoffMatch,
        playoffData: isPlayoffMatch ? {
          playoffRoundId: playoffRoundId ? parseInt(playoffRoundId) : null,
          isSecondLeg,
          winnerTeamId: winnerTeamId ? parseInt(winnerTeamId) : null
        } : null
      }, { headers });
      
      console.log('Odpowiedź z serwera:', response.data);
      alert('Mecz dodany! Przeliczenie Elo w toku...');
      navigate('/janekjot');
    } catch (error) {
      console.error('Błąd podczas wysyłania meczu:', error);
      alert('Błąd podczas dodawania meczu.');
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: '20px', maxWidth: '600px', margin: '0 auto', position: 'relative' }}>
      <Typography variant="h4" gutterBottom>
        Dodaj Mecz Sparingowy
      </Typography>
      <form onSubmit={handleSubmit}>
        <DatePicker
          selected={matchDate}
          onChange={(date) => setMatchDate(date)}
          customInput={<TextField label="Data i godzina meczu" fullWidth margin="normal" />}
          dateFormat="dd/MM/yyyy HH:mm"
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          popperClassName="date-picker-popper"
          portalId="date-picker-portal"
        />

        <Autocomplete
          options={filteredTeamsHome}
          getOptionLabel={(option) => option.name}
          value={homeTeam}
          onChange={(event, newValue) => {
            setHomeTeam(newValue);
            setWinnerTeamId('');
          }}
          inputValue={searchTermHome}
          onInputChange={(event, newInputValue) => setSearchTermHome(newInputValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Gospodarze"
              margin="normal"
              fullWidth
            />
          )}
        />

        <Autocomplete
          options={filteredTeamsAway}
          getOptionLabel={(option) => option.name}
          value={awayTeam}
          onChange={(event, newValue) => {
            setAwayTeam(newValue);
            setWinnerTeamId('');
          }}
          inputValue={searchTermAway}
          onInputChange={(event, newInputValue) => setSearchTermAway(newInputValue || '')}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Goście"
              margin="normal"
              fullWidth
            />
          )}
        />

        <TextField
          label="Gole drużyny gospodarzy"
          type="number"
          value={homeGoals}
          onChange={(e) => setHomeGoals(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Gole drużyny gości"
          type="number"
          value={awayGoals}
          onChange={(e) => setAwayGoals(e.target.value)}
          fullWidth
          margin="normal"
        />

        <FormControlLabel
          control={<Checkbox checked={neutralVenue} onChange={(e) => setNeutralVenue(e.target.checked)} />}
          label="Neutralne miejsce"
          sx={{ mt: 1 }}
        />

        <FormControl component="fieldset" sx={{ mt: 2, display: 'block' }}>
          <FormLabel component="legend">Wartość K:</FormLabel>
          <RadioGroup
            row
            value={kValue}
            onChange={(e) => setKValue(e.target.value)}
          >
            <FormControlLabel value="10" control={<Radio />} label="K = 10" />
            <FormControlLabel value="20" control={<Radio />} label="K = 20" />
          </RadioGroup>
        </FormControl>

        {/* SEKCJA BARAŻOWA */}
        <Divider sx={{ my: 3, borderColor: 'rgba(255, 255, 255, 0.12)' }} />

        <FormControlLabel
          control={
            <Switch 
              checked={isPlayoffMatch} 
              onChange={(e) => setIsPlayoffMatch(e.target.checked)} 
              color="primary"
            />
          }
          label="Powiąż z barażami (Playoff)"
          sx={{ mb: 1, userSelect: 'none' }}
        />

        {isPlayoffMatch && (
          <Box 
            sx={{ 
              p: 2.5, 
              border: '1px solid',
              borderColor: 'primary.main', 
              borderRadius: '8px', 
              mb: 2, 
              backgroundColor: 'rgba(255, 255, 255, 0.03)',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
              backdropFilter: 'blur(4px)'
            }}
          >
            <FormControl fullWidth margin="normal">
              <InputLabel id="playoff-round-select-label">Runda barażowa</InputLabel>
              <Select
                labelId="playoff-round-select-label"
                value={playoffRoundId}
                label="Runda barażowa"
                onChange={(e) => setPlayoffRoundId(e.target.value)}
              >
                {playoffRounds.map((round) => (
                  <MenuItem key={round.id} value={round.id}>
                    {round.template_name} — {round.round_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControlLabel
              control={
                <Checkbox 
                  checked={isSecondLeg} 
                  onChange={(e) => setIsSecondLeg(e.target.checked)} 
                  color="primary"
                />
              }
              label="Mecz rewanżowy (Double-leg / Second leg)"
              sx={{ mt: 1.5, display: 'block', userSelect: 'none' }}
            />

            {homeTeam && awayTeam ? (
              <FormControl component="fieldset" sx={{ mt: 2.5, display: 'block' }}>
                <FormLabel component="legend" sx={{ color: 'primary.main', mb: 1, fontSize: '0.9rem', fontWeight: 500 }}>
                  Zwycięzca (awansujący dalej):
                </FormLabel>
                <RadioGroup
                  value={winnerTeamId}
                  onChange={(e) => setWinnerTeamId(e.target.value)}
                >
                  <FormControlLabel 
                    value={homeTeam.id.toString()} 
                    control={<Radio color="primary" />} 
                    label={`Gospodarz: ${homeTeam.name}`} 
                  />
                  <FormControlLabel 
                    value={awayTeam.id.toString()} 
                    control={<Radio color="primary" />} 
                    label={`Gość: ${awayTeam.name}`} 
                  />
                </RadioGroup>
              </FormControl>
            ) : (
              <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2, fontStyle: 'italic' }}>
                Wybierz gospodarza i gościa, aby wskazać zwycięzcę awansu.
              </Typography>
            )}
          </Box>
        )}

        <Button variant="contained" color="primary" type="submit" sx={{ mt: 2, display: 'block', width: '100%', py: 1.2 }}>
          Dodaj mecz i przelicz Elo
        </Button>
      </form>

      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          bottom: 10,
          right: 10,
          color: 'gray',
          fontSize: '0.6rem',
        }}
      >
      </Typography>
    </Box>
  );
};

export default AddMatch;
